import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IonBackdrop } from '@ionic/angular';

/** Mask ids are document-global, so each instance needs its own or a second
    loader steals the first one's masks (and breaks when that one unmounts). */
let instanceId = 0;

@Component({
  selector: 'nty-loading',
  imports: [IonBackdrop],
  templateUrl: './loading.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  private readonly id = instanceId++;

  readonly maskId1 = `nty-loading-mask-1-${this.id}`;
  readonly maskId2 = `nty-loading-mask-2-${this.id}`;
}
